export class BuildErrorMessages {
    static buildErrorMessages(defaultOverrides, locale, errMsg) {
        //override built-in errors that are in use (see stackoverflow question 2457032 for full list)
        defaultOverrides[locale.enUS] = {};
        defaultOverrides[locale.enCA] = {};
        defaultOverrides[locale.esUS] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido en el formato de (123) 456-7890 x5555.",
        };
        defaultOverrides[locale.esEC] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido con al menos 10 dígitos y no más de 12.",
        };
        defaultOverrides[locale.esMX] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido en el formato de 12 3456 7890.",
        };
        defaultOverrides[locale.esPE] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido con al menos 7 dígitos y no más de 11.",
        };
        defaultOverrides[locale.esPY] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido con al menos 6 dígitos y no más de 9.",
        };
        defaultOverrides[locale.esCO] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido en el formato de 12-3456-7890.",
        };
        defaultOverrides[locale.esCL] = {
            required: "Esta sección es requerida.",
            minlength: "Por favor utilice al menos {0} caracteres.",
            email: "Debe utilizar un correo electrónico válido.",
            tel: "Debe utilizar un número de teléfono válido en el formato de 12 3456 7890.",
        };
        defaultOverrides[locale.ptBR] = {
            required: "Este campo é obrigatório.",
            minlength: "Insira pelo menos {0} caracteres.",
            email: "Digite um E-Mail válido para.",
            tel: "Por favor, digite um número de telefone de 10 dígitos para.",
        };
        //custom error messages
        errMsg[locale.enUS] = {
            nameLetters: "Please enter a valid {0}.",
            phoneFormat: "Please enter a valid phone number in the format {0}.",
            phoneShortFormat: "Please enter a valid phone number in the format {0}.",
            emailFormat: "Please enter a valid email.",
            zipFormat: "Please enter a valid ZIP code.",
            vinFormat: "Please enter a valid 17 character VIN.",
            stateExist: "Please enter a valid state.",
            dateFormat: "Please enter a valid date.",
            licenseFormat: "Please enter a valid license number.",
            ssnFormat: "Please enter a valid SSN.",
            fileFormat: "Please select a valid file type.",
            submissionError: "An error occurred sending the message. Please try again.",
            browse: "Browse...",
            filesSelected: "{count} files selected",
            phoneTypeRequired: "Please select a phone type",
        };
        errMsg[locale.enCA] = {
            nameLetters: errMsg[locale.enUS].nameLetters,
            phoneFormat: errMsg[locale.enUS].phoneFormat,
            phoneShortFormat: errMsg[locale.enUS].phoneShortFormat,
            emailFormat: errMsg[locale.enUS].emailFormat,
            zipFormat: "Please enter a valid postal code.",
            vinFormat: errMsg[locale.enUS].vinFormat,
            stateExist: "Please enter a valid province.",
            dateFormat: errMsg[locale.enUS].dateFormat,
            licenseFormat: errMsg[locale.enUS].licenseFormat,
            ssnFormat: "Please enter a valid SIN.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: errMsg[locale.enUS].submissionError,
            browse: errMsg[locale.enUS].browse,
            filesSelected: errMsg[locale.enUS].filesSelected,
            phoneTypeRequired: errMsg[locale.enUS].phoneTypeRequired,
        };
        errMsg[locale.esUS] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Buscar...",
            filesSelected: "{count} archivos seleccionado",
            phoneTypeRequired: "Seleccione un tipo de teléfono",
        };
        errMsg[locale.esEC] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Adjuntar",
            filesSelected: "{count} archivos seleccionado",
            phoneTypeRequired: errMsg[locale.esUS].phoneTypeRequired,
            dniFormat: "Debe utilizar un Documento Nacional de Identificación válido.",
        };
        errMsg[locale.esMX] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Adjuntar",
            filesSelected: "{count} archivos seleccionado",
            phoneTypeRequired: errMsg[locale.esUS].phoneTypeRequired,
        };
        errMsg[locale.esPE] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido con al menos 7 dígitos y no más de 11.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido con al menos 7 dígitos y no más de 11.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Adjuntar",
            filesSelected: "{count} archivos seleccionado",
            phoneTypeRequired: errMsg[locale.esUS].phoneTypeRequired,
        };
        errMsg[locale.esPY] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Adjuntar",
            filesSelected: "{count} archivos seleccionado",
            phoneTypeRequired: errMsg[locale.esUS].phoneTypeRequired,
            cedulaFormat: "Debe utilizar un Cédula de Identidad válido.",
        };
        errMsg[locale.esCO] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Adjuntar",
            filesSelected: "{count} archivos seleccionado",
            phoneTypeRequired: errMsg[locale.esUS].phoneTypeRequired,
        };
        errMsg[locale.esCL] = {
            nameLetters: "Sólo utilice letras y espacios para su {0}.",
            phoneFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            phoneShortFormat: "Debe utilizar un número de teléfono válido en el formato de {0}.",
            emailFormat: "Debe utilizar un correo electrónico válido.",
            zipFormat: "Debe utilizar un código postal válido.",
            vinFormat: "Debe utilizar un número de VIN de 17 carácteres válido.",
            stateExist: "Debe utilizar un estado válido.",
            dateFormat: "Debe utilizar una fecha valida.",
            licenseFormat: "Debe utilizar un número de licencia válido.",
            ssnFormat: "Debe utilizar un número de seguro social válido.",
            fileFormat: errMsg[locale.enUS].fileFormat,
            submissionError: "Ocurrió un error al enviar el mensaje. Por favor, vuelva a intentarlo.",
            browse: "Adjuntar...",
            filesSelected: "{count} archivos seleccionado",
            rutFormat: "El RUT proveído no es válido, por favor intenta de nuevo",
            phoneTypeRequired: errMsg[locale.esUS].phoneTypeRequired,
        };
        errMsg[locale.ptBR] = {
            nameLetters: "Por favor, insira um {0} válido",
            phoneFormat: "Por favor, digite um número de telefone de 10 dígitos para.",
            phoneShortFormat: "Por favor, digite um número de telefone de 10 dígitos para.",
            emailFormat: "Digite um E-Mail válido para.",
            zipFormat: "Por favor, digite um código postal dos Estados em formato de 5 dígitos para.",
            vinFormat: "Insira um VIN de 17 caracteres válido.",
            stateExist: "Insira uma província válida.",
            dateFormat: "Insira a data válida para.",
            licenseFormat: "Por favor, insira um número da carteira de motorista válido.",
            ssnFormat: "Por favor, digite um Número de Previdência Social válido para.",
            fileFormat: "Selecione um tipo de arquivo válido.",
            submissionError: "Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente.",
            browse: "Navegar...",
            filesSelected: "{count} arquivos selecionados.",
            cpfFormat: "Por favor, insira um número de CPF válido.",
            cnpjFormat: "Por favor, insira um número de CNPJ válido.",
            phoneTypeRequired: "Selecione um tipo de telefone",
        };
    }
}
